// Pure helpers for the Supply chain page: how protected a file is, and what a check result means in plain words.
export const STAGES = {
  good: { label: 'Protected', color: '#4ade80', next: 'Check again' },
  signed: { label: 'Signed only', color: '#fcd34d', next: 'Add attestation' },
  none: { label: 'Not protected', color: '#94a3b8', next: 'Sign this file' },
  gone: { label: 'File deleted', color: '#f87171', next: null }
};

export const stageOf = (r) => {
  if (r.is_purged) return 'gone';
  if (!r.is_signed) return 'none';
  return r.is_attested ? 'good' : 'signed';
};

export function counts(rows) {
  const c = { good: 0, signed: 0, none: 0, gone: 0 };
  rows.forEach((r) => { c[stageOf(r)] += 1; });
  return c;
}

// Turns the answers of the signature check and the attestation check into one verdict.
export function verdict(sig, att) {
  if (sig?.purged || att?.purged) return { kind: 'gone', title: 'The file was deleted', text: 'It was removed after its keeping time ended. This is normal, not tampering.' };
  if (sig?.valid === false) return { kind: 'bad', title: 'This file has changed', text: 'It no longer matches its fingerprint. Treat it as unreliable.' };
  if (att && att.valid === false) return { kind: 'bad', title: 'The attestation does not match', text: 'The file or its attestation was changed after it was made.' };
  return { kind: 'ok', title: 'This is the original file', text: att ? 'Fingerprint and attestation both match.' : 'Fingerprint matches.' };
}

export const orderRows = (rows) => [...rows].sort((a, b) => {
  const rank = { none: 0, signed: 1, good: 2, gone: 3 };
  return rank[stageOf(a)] - rank[stageOf(b)] || Number(b.id) - Number(a.id);
});
